<div *ngIf="loadingService.isLoading$ | async" class="loading-wrapper" [class.full-screen]="fullScreen"
    [class.with-backdrop]="backdrop">

    <div class="loader-container">

        <!-- Spinner de Barras -->
        <div *ngIf="currentSpinner === 'bars'" class="loader bars-loader">
            <span *ngFor="let bar of bars; let i = index" class="loader-bar"
                [style.animation-delay]="getBarsAnimationDelay(i) + 's'"
                [style.background-color]="getRandomColor(i)"></span>
        </div>

        <!-- Spinner de Puntos -->
        <div *ngIf="currentSpinner === 'dots'" class="loader dots-loader">
            <span *ngFor="let dot of dots; let i = index" class="loader-dot"
                [style.animation-delay]="getAnimationDelay(i, dots.length) + 's'"
                [style.background-color]="getRandomColor(i)"></span>
        </div>

        <!-- Spinner de Pulso -->
        <div *ngIf="currentSpinner === 'pulse'" class="loader pulse-loader">
            <span *ngFor="let pulse of pulseElements; let i = index" class="pulse-circle"
                [style.animation-delay]="(i * 0.3) + 's'" [style.border-color]="getRandomColor(i)"></span>
        </div>

        <!-- Spinner de Onda -->
        <div *ngIf="currentSpinner === 'wave'" class="loader wave-loader">
            <span *ngFor="let wave of waveElements; let i = index" class="wave-bar"
                [style.animation-delay]="getAnimationDelay(i, waveElements.length) + 's'"
                [style.background-color]="getRandomColor(i)"></span>
        </div>

        <!-- Spinner de Círculo Mejorado -->
        <div *ngIf="currentSpinner === 'circle'" class="loader circle-loader">
            <span *ngFor="let circle of circleElements; let i = index" class="circle-segment"
                [style.border-top-color]="i < 4 ? getRandomColor(i) : 'transparent'"
                [style.border-right-color]="i < 4 ? getRandomColor(i + 1) : 'transparent'"
                [style.border-bottom-color]="i < 4 ? getRandomColor(i + 2) : 'transparent'"
                [style.border-left-color]="i < 4 ? getRandomColor(i + 3) : 'transparent'">
            </span>
        </div>

        <!-- Spinner Rebote -->
        <div *ngIf="currentSpinner === 'bouncing'" class="loader bouncing-loader">
            <span *ngFor="let bounce of bouncingElements; let i = index" class="bouncing-dot"
                [style.animation-delay]="(i * 0.16) + 's'" [style.background-color]="getRandomColor(i)"></span>
        </div>

        <!-- Spinner Plegable -->
        <div *ngIf="currentSpinner === 'folding'" class="loader folding-loader">
            <span *ngFor="let fold of foldingElements; let i = index" class="folding-cube"
                [style.animation-delay]="(i * 0.1) + 's'" [style.background-color]="getRandomColor(i)"></span>
        </div>

        <!-- Spinner Cubo -->
        <div *ngIf="currentSpinner === 'cube'" class="loader cube-loader">
            <span *ngFor="let cube of cubeElements; let i = index" class="cube"
                [style.animation-delay]="(i * 0.1) + 's'" [style.background-color]="getRandomColor(i)"></span>
        </div>

        <!-- Spinner Giratorio Mejorado -->
        <div *ngIf="currentSpinner === 'spinning'" class="loader spinning-loader">
            <div class="spinning-circle" [style.border-top-color]="getRandomColor(0)"
                [style.border-bottom-color]="getRandomColor(1)"></div>
            <div class="spinning-inner" [style.border-left-color]="getRandomColor(2)"
                [style.border-right-color]="getRandomColor(3)"></div>
        </div>

        <!-- Spinner de Texto "LOADING" -->
        <div *ngIf="currentSpinner === 'text'" class="loader text-loader">
            <div *ngFor="let element of textElements" class="text-letter"
                [style.animation-delay]="(element.index * 0.2) + 's'" [style.left]="element.initialLeft"
                [style.color]="getRandomColor(element.index)">
                {{ element.letter }}
            </div>
        </div>

        <!-- Spinner Esfera 3D -->
        <div *ngIf="currentSpinner === 'sphere'" class="loader sphere-loader">
            <div *ngFor="let element of sphereElements" class="sphere-inner" [class.one]="element === 0"
                [class.two]="element === 1" [class.three]="element === 2"
                [style.border-bottom-color]="element === 0 ? getRandomColor(0) : 'transparent'"
                [style.border-right-color]="element === 1 ? getRandomColor(1) : 'transparent'"
                [style.border-top-color]="element === 2 ? getRandomColor(2) : 'transparent'">
            </div>
        </div>

        <div class="loading-text">
            {{ loadingService.loadingText$ | async }}
        </div>
    </div>
</div>